import axiosInstance from "./axiosConfig";

// Get API URL from environment or use relative path
const API_URL = import.meta.env.VITE_API_URL || "/api/v1";

/**
 * Account service for handling user account-related API calls
 */
const accountService = {
  /**
   * Get user profile with metadata
   * @returns {Promise} User profile data
   */
  getProfile: async () => {
    try {
      const response = await axiosInstance.get(`/account/profile`);
      return response.data;
    } catch (error) {
      console.error("Error fetching profile:", error);
      throw error;
    }
  },

  /**
   * Update user profile
   * @param {Object} data - Profile data to update
   * @returns {Promise} Updated profile data
   */
  updateProfile: async (data) => {
    try {
      const response = await axiosInstance.put(`/account/profile`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating profile:", error);
      throw error;
    }
  },

  /**
   * Change user password
   * @param {Object} data - Password change data
   * @returns {Promise} Success response
   */
  changePassword: async (data) => {
    try {
      const response = await axiosInstance.put(`/account/password`, data);
      return response.data;
    } catch (error) {
      console.error(
        "Error changing password:",
        error.response?.data || error.message
      );
      // Propagate the error so we can handle it in the hook
      throw error;
    }
  },

  /**
   * Update notification preferences
   * @param {Object} data - Notification preferences
   * @returns {Promise} Updated preferences
   */
  updateNotificationPreferences: async (data) => {
    try {
      const response = await axiosInstance.put(`/account/notifications`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating notifications:", error);
      throw error;
    }
  },

  /**
   * Update language preference
   * @param {string} language - Language code
   * @returns {Promise} Updated language preference
   */
  updateLanguage: async (language) => {
    try {
      const response = await axiosInstance.put(`/account/language`, {
        language,
      });
      return response.data;
    } catch (error) {
      console.error("Error updating language:", error);
      throw error;
    }
  },
};

export default accountService;
